import useAppSelector from './useAppSelector';

export default function useRequestCountryCode() {
  return useAppSelector(state => state.requestCountryCode);
}
